var render = function render(){var _vm=this,_c=_vm._self._c;return _c('generic-list',{attrs:{"query-fields":_vm.queryFields,"columns":_vm.columns,"form-fields":_vm.formFields,"editable-fields":_vm.editableFields,"fetch-data":_vm.fetchData,"add-data":_vm.addData,"update-data":_vm.updateData,"delete-data":_vm.deleteData,"add-fields":_vm.addFields}})
}
var staticRenderFns = []

export { render, staticRenderFns }